@for (serie of series; track serie) {
  <svg:g aaColumnGroup></svg:g>
  }
